import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Github } from "lucide-react";

export default function Cordova() {
  return (
    <div>
      <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl font-semibold text-slate-800">Cordova</h1>
        </div>
      </section>

      <article className="max-w-5xl mx-auto px-6 lg:px-10 py-14">
        <Link
          to="/development-kits"
          className="inline-flex items-center gap-1 text-sm text-[#29abe2] hover:underline mb-8"
        >
          <ChevronLeft className="w-4 h-4" /> Back to Development Kits
        </Link>

        <section className="mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">Overview</h2>
          <p className="text-slate-700 leading-relaxed text-[16px]">
            The official JavaScript SDK can also be used for developing cross-platform mobile applications using
            Apache Cordova/PhoneGap. In order to do this, you will have to develop a simple TappyCommunicator
            similar to the{" "}
            <a
              href="https://github.com/TapTrack/TappyNodeSerialCommunicatorJs"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#29abe2] hover:underline"
            >
              TappyNodeSerialCommunicator
            </a>{" "}
            that wraps the Cordova USB serial port (for TappyUSBs) or Bluetooth Low Energy (for TappyBLEs) library
            of your choice. If you wish to take this approach, TapTrack would be be happy to help with your
            integration needs.
          </p>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">
            Unofficial TappyBLE Communicator
          </h2>
          <p className="text-slate-700 leading-relaxed text-[16px]">
            While there are no officially-supported TapTrack-authored communicators for Cordova, one of our
            customers has created an open-source communicator that wraps the BLE Central Cordova plugin into a
            Tappy communicator in order to enable use of TappyBLE devices on Cordova.
          </p>
          <div className="mt-5">
            <a
              href="https://github.com/debugerr/TappyBleBridge"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-slate-800 hover:bg-slate-900 text-white text-sm font-semibold px-5 py-2.5 rounded transition-colors"
            >
              <Github className="w-4 h-4" />
              Get source on GitHub
            </a>
          </div>
        </section>
      </article>
    </div>
  );
}
